export default __webpack_public_path__ + "static/N0241-ad9062e72bc7dca5648c705491a9835f.png";